module.exports = __webpack_public_path__ + "img/btcest-query.55a275a3.png";